function withoutThemingProps(props) {
  const { theme, clearTheme, applyTheme, ...rest } = props;
  return rest;
}

export { withoutThemingProps };
//# sourceMappingURL=without-theming-props.js.map
